import { APP_LINKS } from '@/helpers/links';
import IconDashboard from '@scramble/design-system/icons/home-line.svg?react';
import IconInvesting from '@scramble/design-system/icons/bar-chart-10.svg?react';
import IconCash from '@scramble/design-system/icons/wallet-04.svg?react';
import IconClaims from '@scramble/design-system/icons/percent-03.svg?react';
import IconReports from '@scramble/design-system/icons/file-05.svg?react';
import IconBrands from '@scramble/design-system/icons/grid-01.svg?react';
import IconFriends from '@scramble/design-system/icons/user-plus-01.svg?react';
import IconLoyalty from '@scramble/design-system/icons/star-01.svg?react';
import IconStreak from '@scramble/design-system/icons/flame.svg?react';
import IconQuestions from '@scramble/design-system/icons/help-circle.svg?react';
import IconRounds from '@scramble/design-system/icons/clock.svg?react';
import IconBlog from '@scramble/design-system/icons/book-open-01.svg?react';

export const NAV_ROUTES = t => [
  {
    path: APP_LINKS.dashboard,
    label: t('navigation:dashboard'),
    icon: IconDashboard,
    isNew: false,
  },
  {
    path: APP_LINKS.investing,
    label: t('navigation:investing'),
    icon: IconInvesting,
    isNew: false,
  },
  {
    path: APP_LINKS.addFunds,
    label: t('navigation:cash'),
    icon: IconCash,
    isNew: false,
  },
  {
    path: APP_LINKS.loansList,
    label: t('navigation:loans'),
    icon: IconClaims,
    isNew: false,
  },
  {
    path: APP_LINKS.cash_movements,
    label: t('navigation:reports'),
    icon: IconReports,
    isNew: false,
  },
  {
    path: APP_LINKS.startups,
    label: t('navigation:brands_gallery'),
    icon: IconBrands,
    isNew: false,
  },
  {},
  {
    path: APP_LINKS.affiliate,
    label: t('navigation:invite_friends'),
    icon: IconFriends,
    isNew: false,
  },
  {
    path: APP_LINKS.loyaltyProgram,
    label: t('navigation:loyalty_club'),
    icon: IconLoyalty,
    isNew: false,
  },
  {
    path: APP_LINKS.investmentStreak,
    label: t('navigation:investment_streak'),
    icon: IconStreak,
    isNew: false,
  },
  {},
  {
    path: APP_LINKS.clientQuestions,
    label: t('navigation:investors_questions'),
    icon: IconQuestions,
    isNew: false,
  },
  {
    path: APP_LINKS.roundHistory,
    label: t('navigation:rounds_history'),
    icon: IconRounds,
    isNew: false,
  },
  {
    path: APP_LINKS.blog,
    label: t('navigation:blog'),
    icon: IconBlog,
    isNew: false,
  },
];